export const TUTORIAL_VIDEOS = [
    { key: "drawingCapture", title: "Drawing Capture Tool", youtubeId: "E33J8XJzyeM" },
    { key: "takeoffInputs", title: "Takeoff Inputs", youtubeId: "rBLq6il0Dj4" },
    { key: "upgrades", title: "Upgrades", youtubeId: "vLFuiPs8Ww8" },
    { key: "simulationsAndResults", title: "Simulations & Results", youtubeId: "xBZA6-7MXbc" },
    { key: "parametricAnalysis", title: "Parametric Analysis", youtubeId: "YjVcGqlZUjY" },
];

export const TUTORIAL_VIDEOS_BY_KEY = Object.fromEntries(TUTORIAL_VIDEOS.map((video) => [video.key, video]));

export const QUICKSTART_PATH = "/resources/quickstart";

export const getTutorialVideoUrl = (videoKey) => `${QUICKSTART_PATH}#${videoKey}`;
